import {Component, Input} from '@angular/core';

import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'add-stampling-modal',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Nuova timbratura</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
			<div style='margin:0px auto; width: 132px;'>
      <ngb-timepicker [(ngModel)]="time"></ngb-timepicker>
			</div>
    </div>
    <div class="modal-footer">
			<button type="button" class="btn btn-success" (click)="save()">Aggiungi</button>
      <button type="button" class="btn btn-danger" (click)="close()">Annulla</button>
    </div>
  `
})
export class AddStamplingModal {
  @Input() time: any = {"hour": 12, "minute": 0};

  constructor(public activeModal: NgbActiveModal) {}

	close() {
		this.activeModal.dismiss(null);
	}

	save() {
		this.activeModal.close(JSON.stringify(this.time));
	}
}



// WEBPACK FOOTER //
// /builds/mediaclinicstn/stampling-viewer/src/pages/home/add-stampling-modal.ts